import { makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import RoundedButton from 'components/Shared/RoundedButton';
import UserHeader from './UserHeader';
import { ReactComponent as ShieldLockIcon } from '../../../../assets/icons/shield_lock.svg';

const useStyles = makeStyles((theme) => ({
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(3),
    gap: theme.spacing(3),
    overflow: 'hidden',
  },
  emptyState: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '500px',
    flex: 1,
    padding: theme.spacing(6, 8),
    background: 'linear-gradient(135deg, #fafafa 0%, #ffffff 100%)',
    borderRadius: 16,
    border: '1px solid rgba(0, 0, 0, 0.08)',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      textAlign: 'center',
      padding: theme.spacing(4),
      gap: theme.spacing(4),
    },
  },
  emptyStateInner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    // maxWidth: '900px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      textAlign: 'center',
      gap: theme.spacing(4),
    },
  },
  content: {
    flex: 1,
    maxWidth: '450px',
    paddingRight: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      paddingRight: 0,
      textAlign: 'center',
    },
  },
  illustration: {
    flex: 1,
    // width: '250px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      order: -1,
      width: '100%',
    },
  },
  illustrationIcon: {
    backgroundColor: 'rgba(30, 58, 138, 0.15)', // Semi-transparent dark blue
    borderRadius: '50%',
    width: '200px',
    height: '200px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 4px 20px rgba(30, 58, 138, 0.1)', // Soft shadow in background tone
    '& svg': {
      width: '60%',
      height: '60%',
      fill: 'rgba(30, 58, 138, 0.8)', // Dark blue icon with transparency
    },
    [theme.breakpoints.down('md')]: {
      width: '120px',
      height: '120px',
    },
  },
  title: {
    fontSize: '32px',
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    color: '#333',
    lineHeight: 1.2,
    textAlign: 'left',
    [theme.breakpoints.down('md')]: {
      fontSize: '24px',
      textAlign: 'center',
    },
  },
  subtitle: {
    fontSize: '18px',
    color: '#666',
    marginBottom: theme.spacing(4),
    lineHeight: 1.5,
    textAlign: 'left',
    [theme.breakpoints.down('md')]: {
      fontSize: '16px',
      marginBottom: theme.spacing(3),
      textAlign: 'center',
    },
  },
  actionButton: {
    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
    color: 'white',
    border: 'none',
    padding: theme.spacing(2.25, 4.5),
    borderRadius: 12,
    fontSize: '18px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.3s',
    boxShadow: `0 4px 16px ${theme.palette.primary.main}30`,
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    textTransform: 'none',
    letterSpacing: 'normal',
    '&:hover': {
      transform: 'translateY(-3px)',
      boxShadow: `0 8px 24px ${theme.palette.primary.main}40`,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '16px',
      padding: theme.spacing(1.75, 3.5),
      maxHeight: 50,
    },
  },
  buttonIcon: {
    width: '20px',
    height: '20px',
    fill: 'currentColor',
    transform: 'translate(-5px, 4px)',
  },
}));

const EmptyAccountState = ({ onAddAccount, userData, onUserUpdate }) => {
  const classes = useStyles();
  const { en: { titles, btn } } = useSelector((state) => state.i18n);

  const handleAddClick = () => {
    if (onAddAccount) {
      onAddAccount();
    }
  };

  return (
    <div className={classes.container}>
      {/*/!* User Header *!/*/}
      {/*<UserHeader*/}
      {/*  userData={userData}*/}
      {/*  onUserUpdate={onUserUpdate}*/}
      {/*/>*/}

      {/* Empty State */}
      <div className={classes.emptyState}>
        <div className={classes.emptyStateInner}>
          <div className={classes.content}>
            <h3 className={classes.title}>
              {titles.setupAccountAccess || 'Setup Account Access'}
            </h3>
            <p className={classes.subtitle}>
              {titles.userNeedsAccountAccess || 'This user needs account access to get started. Add their first account and configure permissions.'}
            </p>
            <RoundedButton
              variant="contained"
              color="primary"
              onClick={handleAddClick}
              className={classes.actionButton}
            >
              <svg className={classes.buttonIcon} viewBox="0 0 24 24">
                <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
              </svg>
              {titles.addAccount || 'Add Account'}
            </RoundedButton>
          </div>
          <div className={classes.illustration}>
            <div className={classes.illustrationIcon}>
              <ShieldLockIcon />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyAccountState;
